export default "__VITE_ASSET__NHJ6QB3ZVMf35ip30RyL0A__ 480w, __VITE_ASSET__4QeQqVAUdwGwQIvMHnqk_g__ 745w";